import React, { Component } from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

class ItemInfo extends Component {
  constructor(props) {
    super(props)
  }

  // itemName, handleInfoChange, itemCode

  render() {
    return (
      <div>
        <FormGroup>
          <Label htmlFor='itemName'>Item Name</Label>
          <Input 
            name='itemName' 
            id='itemName' 
            type='text' 
            value={this.props.itemName} 
            onChange={(e) => this.props.handleInfoChange(e)} 
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor='itemCode'>Item Code</Label>
          <Input 
            name='itemCode' 
            id='itemCode' 
            type='text' 
            value={this.props.itemCode} 
            onChange={(e) => this.props.handleInfoChange(e)}
          />
        </FormGroup>
      </div>
    )
  }
}

export default ItemInfo


// WEBPACK FOOTER //
// ./src/components/Content/CreateManageContent/ItemInfo.js